import React from 'react';
import NewHireExceptionIndividual from './components/new-hire-exception-individual';
import NewHireExceptionHistoric from './components/new-hire-exception-historic';
import NewHireChangeFlag from './components/new-hire-change-flag';

const EmployeeRules: React.FC = () => (
  <>
    <NewHireExceptionIndividual />
    <NewHireChangeFlag />
    <NewHireExceptionHistoric />
  </>
);
export default EmployeeRules;
